import { AllIcons } from 'shared/ui/app-icon/types'

export const IS_DIGITAL_TOUR_SUPPORT_ENABLED =
  import.meta.env.VITE_DIGITAL_TOUR_SUPPORT_ENABLED === 'true'

export const ABOUT_TOUR_TOPICS_ICONS: Record<string, AllIcons> = {
  FLIGHT: AllIcons.AIRPLANE_2,
  RESIDENCE: AllIcons.HOTEL,
  TRANSFER: AllIcons.BUS,
  INSURANCE: AllIcons.HEART,
  COMMENT: AllIcons.CHAT,
}

export const DEFAULT_TOUR_SORT_OPTION = 'RECOMMENDED' as const

export const STAR_FILTERS = {
  FIVE: {
    KEY: '5',
    VALUES: ['5'],
  },
  FOUR: {
    KEY: '4',
    VALUES: ['4'],
  },
  THREE_OR_LESS: {
    KEY: '3_or_less',
    VALUES: ['3', '2', '1'],
  },
  NO_STARS: {
    KEY: 'no_stars',
    VALUES: ['0'],
  },
}

export const TOUR_SORT_OPTIONS = [
  { value: 'PRICE_ASC', labelKey: 'tours_block.sort_price_asc' },
  { value: 'RECOMMENDED', labelKey: 'tours_block.sort_recommended' },
  { value: 'PRICE_DESC', labelKey: 'tours_block.sort_price_desc' },
] as const

export const toursEmptyPage =
  'Здравствуйте! Не нашлось туров на мою дату, помогите подобрать другие варианты'

export const flexibleDateRange = 3

export const maxMonthToursCalendar = 15
